import React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  ReferenceInput,
  SelectInput,
  ReferenceField,
  TextField,
  Toolbar,
  SaveButton,
  FormDataConsumer,
  required
} from 'react-admin';

import {
  DomainsTitle
} from './components';

import { getDepthChoices } from '../../components/DepthChoices';
import { getFrequencyChoices } from '../../components/FrequencyChoices';
import { withStyles } from '@material-ui/core/styles';

export const DomainsEdit = (props) => (
  <Edit title={<DomainsTitle/>} {...props} undoable={false}>
    <DomainsEmbeddedEdit {...props} />
  </Edit>
);

const styles = {
  inlineBlock: {
    display: 'inline-block',
  },
};


const DomainSaveToolbar = props => (
  <Toolbar {...props} >
    <SaveButton disabled={props.invalid} data-testid="domain-edit-save-button" className="domain-edit-save-button"/>
  </Toolbar>
);


export const DomainsEmbeddedEdit = withStyles(styles)(({classes, ...props}) => (
  <SimpleForm  {...props} toolbar={<DomainSaveToolbar />} redirect={`/websites/${encodeURIComponent(props.record.website)}`}>
      <ReferenceField label="Consent solution"
                      source="website"
                      reference="websites">
        <TextField source="name"/>
      </ReferenceField>

      <TextInput label="Domain URI" source="canonicalDomain" disabled />
      <TextInput label="Type" source="type" disabled />

      <ReferenceInput label="Default Language"
                      source="defaultLang"
                      data-testid="default-language"
                      reference="languages"
                      validate={required()}
                      filter={{limit_by_website: props.record.website}}
                      sort={{field: 'name', order: 'ASC'}}>
        <SelectInput optionText="name"
                    optionValue="@id"/>
      </ReferenceInput>

      <FormDataConsumer>
        {({
            formData,
            ...rest
          }) =>
          formData && formData.type === 'website' ? (<div {...rest}>
              <SelectInput label="Scanning depth"
                          source="scanningDepth"
                          data-testid="scanning-depth-select"
                          choices={getDepthChoices()}
                          validate={required()} {...rest} />

              <SelectInput label="Scanning frequency"
                          source="scanningFrequency"
                          data-testid="scanning-frequency-select"
                          choices={getFrequencyChoices()}
                          validate={required()} {...rest} />
            </div>
          ) : null
        }
      </FormDataConsumer>
    </SimpleForm>
));
